import { initPostHogIfAllowed } from '@/lib/tracking/posthog-client';

// Earliest point on every full page load, so /app keeps exception capture from the first
// tick. On marketing pages this does nothing until the visitor accepts cookies; the cookie
// banner then calls initPostHogIfAllowed again (src/components/Cookies.tsx).
initPostHogIfAllowed();
